export default __webpack_public_path__ + "8c4516c52b9adc82164334445e4eb33b.woff";